import {
  IonToolbar,
  IonTitle,
  IonButtons,
  IonButton,
  IonImg,
} from '@ionic/react';
import { BsInstagram } from 'react-icons/bs';

export default function PublicToolbar({ title }: { title: string }) {
  return (
    <IonToolbar color={'primary'} className=''>
      <IonButtons slot='start'>
        <IonButton href='/'>
          <IonImg src={'/assets/icon/icon-white.png'} className='w-8 h-8' />
        </IonButton>
      </IonButtons>
      <IonTitle color={'light'} className='uppercase'>
        {title}
      </IonTitle>
      <IonButtons slot='end'>
        <a href='https://www.instagram.com/cdrt_consorzio/' target='_blank'>
          <BsInstagram color='primary' className='w-6 h-6 ' />
        </a>
      </IonButtons>
    </IonToolbar>
  );
}
